import { z } from "zod";
import { Id } from "../common/ids.js";
import { defineRoute } from "../http/route.js";
import { ProductView } from "./listing.js";
/** Putting products on sale and taking them off (CAT-4, CAT-5, ENT-4, card 038). */
const Publisher = { surface: "tenant", auth: "user", permission: "product:publish" };
const ProductId = z.object({ productId: Id });
const GATE = [
    "ENTERPRISE_NOT_VERIFIED",
    "ENTERPRISE_SUSPENDED",
    "AGREEMENT_ACCEPTANCE_REQUIRED",
    "KYB_NOT_ACTIVE",
];
export const submitProduct = defineRoute({
    ...Publisher,
    id: "catalog.products.submit",
    method: "POST",
    path: "/v1/shop/products/{productId}/submit",
    marks: ["tenant", "verified", "if-match"],
    summary: "Submit a draft, or the pending revision of a published product, at the version read. It must be complete. It goes live at once, or waits for operators when it matches the prohibited or export-control lists. Needs the seller agreement in force, an active shop, and a shop that can sell (`403 KYB_NOT_ACTIVE`): its bank account on file while trade is paid offline (ADR 0021), otherwise an active payout account",
    prd: ["CAT-4", "CAT-5", "ENT-4"],
    request: { params: ProductId },
    responses: { 200: { description: "The product, live or in review", schema: ProductView } },
    errors: [
        "AUTH_REQUIRED",
        "TENANT_REQUIRED",
        "PERMISSION_DENIED",
        ...GATE,
        "NOT_FOUND",
        "VALIDATION_FAILED",
        "INVALID_TRANSITION",
        "VERSION_CONFLICT",
    ],
});
export const unlistProduct = defineRoute({
    ...Publisher,
    id: "catalog.products.unlist",
    method: "POST",
    path: "/v1/shop/products/{productId}/unlist",
    marks: ["tenant"],
    summary: "Take a live product off shelf; public pages and search drop it",
    prd: ["CAT-4"],
    request: { params: ProductId },
    responses: { 200: { description: "The product, off shelf", schema: ProductView } },
    errors: ["AUTH_REQUIRED", "TENANT_REQUIRED", "PERMISSION_DENIED", "NOT_FOUND", "INVALID_TRANSITION"],
});
export const relistProduct = defineRoute({
    ...Publisher,
    id: "catalog.products.relist",
    method: "POST",
    path: "/v1/shop/products/{productId}/relist",
    marks: ["tenant", "verified"],
    summary: "Put an off-shelf product back on sale, as it was published; the selling gate applies as on submission",
    prd: ["CAT-4", "ENT-4"],
    request: { params: ProductId },
    responses: { 200: { description: "The product, live", schema: ProductView } },
    errors: [
        "AUTH_REQUIRED",
        "TENANT_REQUIRED",
        "PERMISSION_DENIED",
        ...GATE,
        "NOT_FOUND",
        "INVALID_TRANSITION",
    ],
});
export const publishingRoutes = [submitProduct, unlistProduct, relistProduct];
//# sourceMappingURL=publishing.routes.js.map